var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_1383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.8001V11.4001M6.2 8.6001H11.8M16 8.6001C16 12.4661 12.866 15.6001 9 15.6001C5.13401 15.6001 2 12.4661 2 8.6001C2 4.7341 5.13401 1.6001 9 1.6001C12.866 1.6001 16 4.7341 16 8.6001Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_1383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 16.8,
    fill: "white",
    transform: "translate(0.600006 0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.3d50ed12c1d70c6deb61e869636923c1.svg";
export { ForwardRef as ReactComponent };